import futureForward from '@/assets/challenges/future-forward.png';
import inventAndEngineerIt from '@/assets/challenges/invent-and-engineer-it.png';
import mentalHealthForYouth from '@/assets/challenges/mental-health-for-youth.png';
import smartMachinesAndToughDecisions from '@/assets/challenges/smart-machines-and-tough-decisions.png';
import techForAGreenerFuture from '@/assets/challenges/tech-for-a-greener-future.png';
import theHumanSideOfHealthcare from '@/assets/challenges/the-human-side-of-healthcare.png';

export const CHALLENGE_SOURCES = ['KnoPro'] as const;

export type ChallengeSource = typeof CHALLENGE_SOURCES[number];

export interface Challenge {
    slug: string;
    title: string;
    description: string;
    url: string;
    imageUrl: string;
    source: ChallengeSource;
}

// A fixed catalog from the provider rather than ingested content, so it lives here instead of in
// a table. Covers are bundled assets named after the slug, which is why none is ever stored.
export const CHALLENGES: Challenge[] = [
    {
        slug: 'invent-and-engineer-it',
        title: 'Invent and Engineer It',
        description: 'Step into the shoes of an engineer solving real-world problems through trial and error. From bridges to apps, explore how creative thinking, science, and hands-on design principles come together to invent technology that shapes our world.',
        url: 'https://www.knopro.org/skillbuilders/invent-and-engineer-it/',
        imageUrl: inventAndEngineerIt,
        source: 'KnoPro',
    },
    {
        slug: 'future-forward',
        title: 'Future Forward',
        description: 'Fast-forward to the year 2050! Your challenge is to dream up a futuristic invention that could transform daily life. Explore emerging tech trends and build the innovation skills you need to lead what’s next.',
        url: 'https://www.knopro.org/skillbuilders/future-forward/',
        imageUrl: futureForward,
        source: 'KnoPro',
    },
    {
        slug: 'the-human-side-of-healthcare',
        title: 'The Human Side of Healthcare',
        description: 'Delve into healthcare beyond the clinic! Explore how workplace culture, and non-medical factors impact patient care. Learn how empathy, clear communication, and non-clinical roles drive better health outcomes for communities.',
        url: 'https://www.knopro.org/skillbuilders/skb-2025-11-24-more-than-what-you-wear-1/',
        imageUrl: theHumanSideOfHealthcare,
        source: 'KnoPro',
    },
    {
        slug: 'mental-health-for-youth',
        title: 'Mental Health for YOUth',
        description: 'Explore critical mental health issues like emotional well-being and access to counseling. Learn practical tools to effectively advocate for yourself and your peers.',
        url: 'https://www.knopro.org/skillbuilders/skb-11-7-2023-the-voting-age-conundrum-1/',
        imageUrl: mentalHealthForYouth,
        source: 'KnoPro',
    },
    {
        slug: 'smart-machines-and-tough-decisions',
        title: 'Smart Machines & Tough Decisions',
        description: 'Tackle the ethical dilemmas behind modern automation. Evaluate real-world scenarios where AI and smart machines make complex choices, and learn how human values and responsible design must guide technology to keep us safe.',
        url: 'https://www.knopro.org/skillbuilders/smart-machines-and-tough-choices-1/',
        imageUrl: smartMachinesAndToughDecisions,
        source: 'KnoPro',
    },
    {
        slug: 'tech-for-a-greener-future',
        title: 'Tech for a Greener Future',
        description: 'See how technology fights environmental threats, like using specialized tech to battle steep-terrain wildfires in Portugal. Discover green innovations and design solutions that tackle climate change to protect our planet’s future.',
        url: 'https://www.knopro.org/skillbuilders/tech-for-a-greener-future/',
        imageUrl: techForAGreenerFuture,
        source: 'KnoPro',
    },
];
